import React, { useEffect, useState } from "react";
import api from "../../lib/api";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  useEffect(() => {
    api.get("/admin/customers").then((r) => setCustomers(r.data || []));
  }, []);

  return (
    <div className="p-8 md:p-12" data-testid="admin-customers">
      <header className="mb-8">
        <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Atelier</p>
        <h1 className="font-serif text-5xl mt-2">Customers</h1>
      </header>
      <div className="bg-poche-ink border border-white/10">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[10px] tracking-luxury uppercase text-white/45 border-b border-white/10">
              <th className="text-left p-4">Name</th>
              <th className="text-left p-4">Email</th>
              <th className="text-left p-4">Tier</th>
              <th className="text-left p-4">Points</th>
              <th className="text-left p-4">Fit Profile</th>
              <th className="text-left p-4">Joined</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((c) => (
              <tr key={c.user_id} className="border-b border-white/5" data-testid={`customer-${c.user_id}`}>
                <td className="p-4">{c.name}</td>
                <td className="p-4 text-white/65">{c.email}</td>
                <td className="p-4"><span className="text-[10px] tracking-luxury uppercase border border-poche-gold/40 text-poche-gold px-2 py-1">{c.loyalty_tier}</span></td>
                <td className="p-4 font-serif text-poche-gold">{c.loyalty_points}</td>
                <td className="p-4 text-xs">{c.fit_profile ? `${c.fit_profile.face_shape} · ${c.fit_profile.nose_bridge}` : "—"}</td>
                <td className="p-4 text-xs text-white/55">{new Date(c.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
            {customers.length === 0 && (
              <tr><td colSpan={6} className="p-10 text-center text-white/45">No customers yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
